// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListMetricVariation {
  display: inline-flex;
  padding-left: 4px;
  height: 100%;
}
.ListMetricVariation .variation-centered .metric-variation.metric-variation-positive {
  color: var(--success);
}
.ListMetricVariation .variation-centered .metric-variation.metric-variation-negative {
  color: var(--danger);
}

.ListMetricVariation.tooltiLabel {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 1px;
  cursor: default;
}
.ListMetricVariation.tooltiLabel .variation-centered {
  padding-bottom: 5px;
}
.ListMetricVariation.tooltiLabel .ListMetricVariation-date {
  font-size: 12px;
  color: var(--gray_dark1);
}`, "",{"version":3,"sources":["webpack://./src/components/ListMetricVariation/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,iBAAA;EACA,YAAA;AACF;AAGM;EACE,qBAAA;AADR;AAGM;EACE,oBAAA;AADR;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,eAAA;EACA,wBAAA;AALJ","sourcesContent":[".ListMetricVariation {\n  display: inline-flex;\n  padding-left: 4px;\n  height: 100%;\n\n  .variation-centered {\n    .metric-variation {\n      &.metric-variation-positive {\n        color: var(--success);\n      }\n      &.metric-variation-negative {\n        color: var(--danger);\n      }\n    }\n  }\n}\n\n.ListMetricVariation.tooltiLabel {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-bottom: 1px;\n  cursor: default;\n\n  .variation-centered {\n    padding-bottom: 5px;\n  }\n\n  .ListMetricVariation-date {\n    font-size: 12px;\n    color: var(--gray_dark1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
